import {
  DateInput as MantineDateInput,
  DateInputProps as MantineDateInputProps,
} from "@mantine/dates"
import { IconCalendar } from "@tabler/icons-react"

type DateInputProps = Omit<MantineDateInputProps, "leftSection">

export function DateInput(props: DateInputProps) {
  return (
    <MantineDateInput leftSection={<IconCalendar size={12} />} {...props} />
  )
}
